const FlowBCDT = () => import("@/presentation/view/resources/bcdt/flow-bcdt/flow-bcdt.vue");
const DataBCDT = () => import("@/presentation/view/resources/bcdt/data-bcdt/data-bcdt.vue");
const TelecomLicenseFee = () => import("@/presentation/view/resources/IssueADispatch/TelecomLicenseFee/TelecomLicenseFee.vue");
const FeeTrackingCCDV = () => import("@/presentation/view/resources/FeeManagementCCDV/FeeTrackingCCDV/FeeTrackingCCDV.vue");
const ReceiptBCDT = () => import("@/presentation/view/resources/receipt-bcdt/receipt-bcdt.vue");
const CreateReceiptBCDT = () => import("@/presentation/view/resources/receipt-bcdt/create/create_receipt_bcdt.vue");
const ViewReceiptBCDT = () => import("@/presentation/view/resources/receipt-bcdt/view/view_receipt_bcdt.vue");
const ReceiptSettlement = () => import("@/presentation/view/resources/receipt-fees/receipt-settlement/receiptSettlement.vue");
const ReceiptDeclarations = () => import("@/presentation/view/resources/receipt-fees/receipt-declarations/receiptDeclarations.vue");
const AccountingLiabilitiesCCDV = () => import("@/presentation/view/resources/FeeManagementCCDV/AccountingLiabilitiesCCDV/AccountingLiabilitiesCCDV.vue");
const AccumulatedDebtCCDV = () => import("@/presentation/view/resources/FeeManagementCCDV/AccumulatedDebtCCDV/AccumulatedDebtCCDV.vue");
const TelecomDebtCCDV = () => import("@/presentation/view/resources/FeeManagementCCDV/TelecomDebtCCDV/TelecomDebtCCDV.vue");
const AccountingLiabilitiesTLM = () => import("@/presentation/view/resources/FeeManagementTLM/AccountingLiabilitiesTLM/AccountingLiabilitiesTLM.vue");
const AccumulatedDebtTLM = () => import("@/presentation/view/resources/FeeManagementTLM/AccumulatedDebtTLM/AccumulatedDebtTLM.vue");
const FeeTrackingTLM = () => import("@/presentation/view/resources/FeeManagementTLM/FeeTrackingTLM/FeeTrackingTLM.vue");
const Home = () => import("@/core/home/home.vue");

//Company
const ListCompany = () => import("@/presentation/view/resources/Company/list/Company.vue");
const CompanyGeneral = () => import("@/presentation/view/resources/Company/Company-info.vue");
const IncomeFee = () => import("@/presentation/view/resources/IncomeFee/IncomeFee.vue");
const OneTimeFee = () => import("@/presentation/view/resources/OneTimeFee/OneTimeFee.vue");
//Kho so
const DeeFetail = () => import("@/presentation/view/resources/WarehouseNo/fee-detail/fee-detail.vue");
const FeeList = () => import("@/presentation/view/resources/WarehouseNo/fee-list/fee-list.vue");
const FeeNumber = () => import("@/presentation/view/resources/WarehouseNo/FeeNember/FeeNumber.vue");
const FeeTrackingKS = () => import("@/presentation/view/resources/WarehouseNo/FeeTrackingKS/FeeTrackingKS.vue");

// el-form
const crete_Elform = () => import("@/presentation/view/resources/FromElectronic/create/create_elForm.vue");

const AccountKS = () => import("@/presentation/view/resources/DebtNoKS/AccountKS/AccountKS.vue");
const AclatedKS = () => import("@/presentation/view/resources/DebtNoKS/AclatedKS/AclatedKS.vue");
const TelecoKS = () => import("@/presentation/view/resources/DebtNoKS/TelecoKS/TelecoKS.vue");
const WareDispatch = () => import("@/presentation/view/resources/IssueADispatch/WarehouseDispatchNo/WarehouseDispatchNo.vue");
// biểu mẫu điện tử
const FromElectronic = () => import("@/presentation/view/resources/FromElectronic/FromElectronic.vue");
// Công văn
const DisManage = () => import("@/presentation/view/resources/DispatchManagement/DisManage.vue");
const ImportDisTo = () => import("@/presentation/view/resources/DispatchManagement/import-dis-to/ImportDisTo.vue");
const AddDisTo = () => import("@/presentation/view/resources/DispatchManagement/add/add-dispatch-to/add-dis-to.vue");
const AddDisSend = () => import("@/presentation/view/resources/DispatchManagement/add/add-dispatch-send/add-dis-send.vue");
const ViewSend = () => import("@/presentation/view/resources/DispatchManagement/view/view-send/view_send.vue");
const ViewTo = () => import("@/presentation/view/resources/DispatchManagement/view/view-to/view_to.vue");

// Cáp biển
const SeaCable = () => import("@/presentation/view/resources/SeaCable/SeaCable.vue");
// Tờ khai thuế DeclarationTax
const DeclarationTax = () => import("@/presentation/view/resources/DeclarationTax/DeclarationTax.vue");
const DetailDeclaration = () => import("@/presentation/view/resources/DeclarationTax/DetailDeclaration/DetailDeclaration.vue");
const HistoryTraces = () => import("@/presentation/view/resources/DeclarationTax/History-traces/History-traces.vue");
const AddDeclaration = () => import("@/presentation/view/resources/DeclarationTax/AddDeclaration/AddDeclaration.vue");
// SMS
const SmsCompany = () => import("@/presentation/view/resources/Sms/SmsComp.vue");
const ControlComp = () => import("@/presentation/view/resources/Sms/Control-Comp/Control-Comp.vue");
const HistorySms = () => import("@/presentation/view/resources/History-Sms/History-Sms.vue");
// Danh sách Chi cục Thuế
const TaxDepartment = () => import("@/presentation/view/resources/TaxDepartment/TaxDepartment.vue");
const AddTaxDepartment = () => import("@/presentation/view/resources/TaxDepartment/Add-TaxDepartment/Add-TaxDepartment.vue");
const EditTaxDepartment = () => import("@/presentation/view/resources/TaxDepartment/Edit-TaxDepartment/Edit-TaxDepartment.vue");
// Mưc thu phí lệ phí
const CollectionRates = () => import("@/presentation/view/resources/CollectionRates/CollectionRates.vue");
const Controller_CollectionRates = () => import("@/presentation/view/resources/CollectionRates/Controller_CollectionRates/Controller_CollectionRates.vue");
// Danh mục địa danh
const ListPlace = () => import("@/presentation/view/resources/ListPlace/ListPlace.vue");
const ViewPlace = () => import("@/presentation/view/resources/ListPlace/view/ViewPlace.vue");
//Login
const Login = () => import("@/core/login/login.vue");

// Nhóm quyền
const UserAmtrator = () => import("@/presentation/view/resources/Admin/UserAdministrator/UserAdministrator.vue");
const ImpactHistory = () => import("@/presentation/view/resources/Admin/ImpactHistory/ImpactHistory.vue");
const CreateUserAmtrator = () => import("@/presentation/view/resources/Admin/UserAdministrator/Create-UserAdmstrtor/Create-UserAdmstrtor.vue");
// Xử phạt hành chính
const AdministrativeSanctions = () => import("@/presentation/view/resources/AdministrativeSanctions/AdministrativeSanctions.vue");
const ViewAdministrativeSanctions = () => import("@/presentation/view/resources/AdministrativeSanctions/ViewAdministrativeSanctions/ViewAdministrativeSanctions.vue");
const CreateAdministrativeSanctions = () => import("@/presentation/view/resources/AdministrativeSanctions/CreateAdministrativeSanctions/CreateAdministrativeSanctions.vue");
// Danh sách tài khoản người dùng
const UserAccount = () => import("@/presentation/view/resources/Admin/UserAccount/UserAccount.vue");
const CreateAccount = () => import("@/presentation/view/resources/Admin/UserAccount/CreateAccount/CreateAccount.vue");
// Báo cáo thống kê
const DeclareStatisticYear = () => import("@/presentation/view/resources/DeclareStatisticYear/DeclareStatisticYear.vue");
const DeclareStatisticDay = () => import("@/presentation/view/resources/DeclareStatisticDay/DeclareStatisticDay.vue");
const DeclareStatisticPeople = () => import("@/presentation/view/resources/DeclareStatisticPeople/DeclareStatisticPeople.vue");

// Xuat cong van cham nop phi
const SentSlow = () => import("@/presentation/view/resources/SentSlow/SentSlow.vue");

const PersonalInfo = () => import("@/presentation/view/resources/Admin/PersonalInfo/PersonalInfo.vue");

const ToolImport = () => import("@/core/tool/tool-import.vue");

export default [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { authorities: [48] },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: { authorities: [48] },
  },
  {
    path: "/flow-bcdt",
    name: "flow-bcdt",
    component: FlowBCDT,
    meta: { authorities: [2] },
  },
  {
    path: "/data-bcdt",
    name: "data-bcdt",
    component: DataBCDT,
    meta: { authorities: [3] },
  },
  {
    path: "/telecom-ficense-fee",
    name: "telecom-ficense-fee",
    meta: { authorities: [5] },
    component: TelecomLicenseFee,
  },
  {
    path: "/fee-tracking-CCDV",
    name: "fee-tracking-CCDV",
    meta: { authorities: [8] },
    component: FeeTrackingCCDV,
  },
  {
    path: "/receipt-bcdt",
    name: "receipt-bcdt",
    meta: { authorities: [28] },
    component: ReceiptBCDT,
  },
  {
    path: "/receipt-bcdt/create",
    meta: { authorities: [28] },
    name: "/receipt-bcdt-create",
    component: CreateReceiptBCDT,
  },
  {
    path: "/receipt-bcdt/:receiptId/view",
    meta: { authorities: [28] },
    name: "/receipt-bcdt-view",
    component: ViewReceiptBCDT,
  },
  {
    path: "/receipt-bcdt/:receiptId/edit",
    meta: { authorities: [28] },
    name: "/receipt-bcdt-edit",
    component: CreateReceiptBCDT,
  },
  {
    path: "/receipt-settlement",
    name: "receipt-settlement",
    meta: { authorities: [30] },
    component: ReceiptSettlement,
  },
  {
    path: "/receipt-declarations",
    name: "receipt-declarations",
    meta: { authorities: [29] },
    component: ReceiptDeclarations,
  },
  {
    path: "/telecom-debt",
    name: "telecom-debt",
    meta: { authorities: [9] },
    component: TelecomDebtCCDV,
  },
  {
    path: "/accumulated-debt",
    name: "accumulated-debt",
    meta: { authorities: [11] },
    component: AccumulatedDebtCCDV,
  },
  {
    path: "/accounting-liabilities",
    name: "accounting-liabilities",
    meta: { authorities: [10] },
    component: AccountingLiabilitiesCCDV,
  },
  {
    path: "/accounting-liabilities-tlm",
    name: "accounting-liabilities-tlm",
    meta: { authorities: [15] },
    component: AccountingLiabilitiesTLM,
  },
  {
    path: "/accumulated-debt-tlm",
    name: "accumulated-debt-tlm",
    meta: { authorities: [16] },
    component: AccumulatedDebtTLM,
  },
  {
    path: "/fee-tracking-tlm",
    meta: { authorities: [13] },
    name: "fee-tracking-tlm",
    component: FeeTrackingTLM,
  },
  //Company
  {
    path: "/company-list",
    name: "company-list",
    meta: { authorities: [32] },
    component: ListCompany,
  },
  {
    path: "/company-list/:companyid",
    name: "company-Info",
    meta: { authorities: [52, 53, 54, 55, 56, 57] },
    component: CompanyGeneral,
  },
  {
    path: "/income-fee",
    name: "income-fee",
    meta: { authorities: [58] },
    component: IncomeFee,
  },
  {
    path: "/one-time-fee",
    name: "one-time-fee",
    meta: { authorities: [24] },
    component: OneTimeFee,
  },
  // kho so
  {
    path: "/fee-list",
    name: "fee-list",
    meta: { authorities: [18] },
    component: FeeList,
  },
  {
    path: "/dee-fetail",
    name: "dee-fetail",
    meta: { authorities: [18] },
    component: DeeFetail,
  },
  {
    path: "/fee-tracking-ks",
    name: "fee-tracking-ks",
    component: FeeTrackingKS,
    meta: { authorities: [19] },
  },
  {
    path: "/fee-number",
    name: "fee-number",
    meta: { authorities: [59] },
    component: FeeNumber,
  },

  {
    path: "/account-ks",
    name: "account-ks",
    meta: { authorities: [21] },
    component: AccountKS,
  },
  {
    path: "/aclated-ks",
    name: "aclated-ks",
    meta: { authorities: [22] },
    component: AclatedKS,
  },
  {
    path: "/teleco-ks",
    name: "teleco-ks",
    meta: { authorities: [20] },
    component: TelecoKS,
  },
  {
    path: "/ware-dispatch",
    name: "ware-dispatch",
    meta: { authorities: [6] },
    component: WareDispatch,
  },

  // el-form

  {
    path: "/electronic-form",
    name: "electronic-form",
    meta: { authorities: [39] },
    component: FromElectronic,
  },
  {
    path: "/electronic-form/create",
    name: "electronic-form-create",
    meta: { authorities: [39] },
    component: crete_Elform,
  },
  {
    path: "/electronic-form/:id/view",
    name: "electronic-form-view",
    meta: { authorities: [39] },
    component: crete_Elform,
  },
  {
    path: "/electronic-form/:id/edit",
    name: "electronic-form-edit",
    meta: { authorities: [39] },
    component: crete_Elform,
  },
  {
    path: "/dis-manage",
    name: "dis-manage",
    meta: { authorities: [31] },
    component: DisManage,
  },
  {
    path: "/dis-manage/:receiptId/view-send",
    name: "/dis-view-send",
    meta: { authorities: [31] },
    component: ViewSend,
  },
  {
    path: "/dis-manage/:receiptId/view-to",
    name: "/dis-view-to",
    meta: { authorities: [31] },
    component: ViewTo,
  },
  {
    path: "/dis-manage/:receiptId/edit-send",
    name: "/dis-edit-send",
    meta: { authorities: [31] },
    component: AddDisSend,
  },
  {
    path: "/dis-manage/:receiptId/edit-to",
    name: "/dis-edit-TO",
    meta: { authorities: [31] },
    component: AddDisTo,
  },
  // {
  //   path: "/dis-manage/:receiptId/edit-dis-management",
  //   name: "/edit-dis-management",
  //   component: AddDisSend,
  // },
  {
    path: "/dis-manage/:receiptId/edit-import",
    name: "/edit-import",
    meta: { authorities: [31] },
    component: ImportDisTo,
  },
  {
    path: "/dis-manage/add-import",
    name: "/import-dis",
    meta: { authorities: [31] },
    component: ImportDisTo,
  },
  {
    path: "/dis-manage/add-send",
    name: "/add-dis-send",
    meta: { authorities: [31] },
    component: AddDisSend,
  },
  {
    path: "/dis-manage/add-to",
    name: "/add-dis-to",
    meta: { authorities: [31] },
    component: AddDisTo,
  },
  // Cáp biển

  {
    path: "/sea-cable",
    name: "sea-cable",
    meta: { authorities: [25] },
    component: SeaCable,
  },

  // Xuat cong van

  {
    path: "/sent-slow",
    name: "sent-slow",
    meta: { authorities: [25] },
    component: SentSlow,
  },

  //
  {
    path: "/declaration-tax",
    name: "declaration-tax",
    meta: { authorities: [38] },
    component: DeclarationTax,
  },
  {
    path: "/declaration-tax/:receiptId/view",
    name: "/detail-declaration",
    meta: { authorities: [38] },
    component: DetailDeclaration,
  },
  {
    path: "/declaration-tax/add-declartion",
    name: "/add-declartion",
    meta: { authorities: [38] },
    component: AddDeclaration,
  },
  {
    path: "/declaration-tax/:receiptId/edit-declartion",
    name: "/edit-declartion",
    meta: { authorities: [38] },
    component: AddDeclaration,
  },
  {
    path: "/declaration-tax/history-traces",
    name: "/history-traces",
    meta: { authorities: [38] },
    component: HistoryTraces,
  },
  // SMS
  {
    path: "/sms-company",
    name: "sms-company",
    meta: { authorities: [42] },
    component: SmsCompany,
  },
  {
    path: "/sms-company/:receiptId/view",
    name: "/detail-declaration",
    meta: { authorities: [42] },
    component: ControlComp,
  },
  {
    path: "/sms-company/:receiptId/edit",
    name: "/edit-sms",
    meta: { authorities: [42] },
    component: ControlComp,
  },
  {
    path: "/history-sms",
    name: "history-sms",
    meta: { authorities: [43] },
    component: HistorySms,
  },
  // Chi cục thuế
  {
    path: "/tax-department",
    name: "tax-department",
    meta: { authorities: [36] },
    component: TaxDepartment,
  },
  {
    path: "/tax-department/:receiptId/edit",
    name: "/edit-tax-department",
    meta: { authorities: [36] },
    component: EditTaxDepartment,
  },
  {
    path: "/tax-department/add",
    name: "tax-department/add",
    meta: { authorities: [36] },
    component: AddTaxDepartment,
  },
  // Mức thu phí, lệ phí
  {
    path: "/collection_rates",
    name: "collection_rates",
    meta: { authorities: [36] },
    component: CollectionRates,
  },
  {
    path: "/collection_rates/create",
    name: "collection_rates/create",
    meta: { authorities: [36] },
    component: Controller_CollectionRates,
  },
  {
    path: "/collection_rates/:receiptId/edit",
    name: "collection_rates/edit",
    meta: { authorities: [36] },
    component: Controller_CollectionRates,
  },
  {
    path: "/collection_rates/:receiptId/view",
    name: "collection_rates/view",
    meta: { authorities: [36] },
    component: Controller_CollectionRates,
  },
  // Danh mục dịa danh
  {
    path: "/list-place",
    name: "list-place",
    meta: { authorities: [40] },
    component: ListPlace,
  },
  {
    path: "/list-place/add",
    name: "add-place",
    meta: { authorities: [40] },
    component: ViewPlace,
  },
  {
    path: "/list-place/:provinceId/edit",
    name: "edit-place",
    meta: { authorities: [40] },
    component: ViewPlace,
  },

  //  Nhóm quyền
  {
    path: "/user-administrator",
    name: "user-administrator",
    component: UserAmtrator,
    meta: { authorities: [47] },
  },
  {
    path: "/user-administrator/create",
    name: "user-administrator/create",
    component: CreateUserAmtrator,
    meta: { authorities: [47] },
  },
  {
    path: "/user-administrator/:receiptId/edit",
    name: "user-administrator/edit",
    meta: { authorities: [47] },
    component: CreateUserAmtrator,
  },
  {
    path: "/user-administrator/:receiptId/view",
    name: "user-administrator/view",
    meta: { authorities: [47] },
    component: CreateUserAmtrator,
  },
  {
    path: "/impact-history",
    name: "impact-history",
    meta: { authorities: [44] },
    component: ImpactHistory,
  },

  // Báo cáo thống kê
  {
    path: "/declareStatistic-year",
    name: "declareStatistic-year",
    meta: { authorities: [51] },
    component: DeclareStatisticYear,
  },
  {
    path: "/declareStatistic-day",
    name: "declareStatistic-day",
    meta: { authorities: [49] },
    component: DeclareStatisticDay,
  },
  {
    path: "/declareStatistic-people",
    name: "declareStatistic-people",
    meta: { authorities: [50] },
    component: DeclareStatisticPeople,
  },

  // Xử phạt hành chính
  {
    path: "/administrative-sanctions",
    name: "administrative-sanctions",
    meta: { authorities: [33] },
    component: AdministrativeSanctions,
  },
  {
    path: "/administrative-sanctions/add",
    name: "administrative-sanctions/add",
    meta: { authorities: [33] },
    component: CreateAdministrativeSanctions,
  },
  {
    path: "/administrative-sanctions/:receiptId/edit",
    name: "administrative-sanctions/edit",
    meta: { authorities: [33] },
    component: ViewAdministrativeSanctions,
  },
  {
    path: "/administrative-sanctions/:receiptId/view",
    name: "administrative-sanctions/view",
    meta: { authorities: [33] },
    component: ViewAdministrativeSanctions,
  },
  //Danh sách tài khoản người dùng
  {
    path: "/personal-info",
    name: "personal-info",
    meta: {
      authorities: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
      ],
    },
    component: PersonalInfo,
  },
  {
    path: "/user-account",
    name: "user-account",
    meta: { authorities: [46] },
    component: UserAccount,
  },
  {
    path: "/user-account/add",
    name: "/user-account/add",
    meta: { authorities: [46] },
    component: CreateAccount,
  },
  {
    path: "/user-account/:receiptId/edit",
    name: "/user-account/edit",
    meta: { authorities: [46] },
    component: CreateAccount,
  },
  {
    path: "/user-account/:receiptId/view",
    name: "/user-account/view",
    meta: { authorities: [46] },
    component: CreateAccount,
  },

  {
    path: "/tool-import",
    name: "/ToolImport",
    meta: { authorities: [46, 44] },
    component: ToolImport,
  },
];
